// extracted by mini-css-extract-plugin
export default {"link":"Link-link-RInnp","to":"Link-to-kylTi"};